const SENSITIVE_PARAMS = new Set([
  "oobcode",
  "mode",
  "apikey",
  "token",
  "code",
  "continueurl",
  "state",
  "id_token",
  "access_token",
]);

const AUTH_PATHS = ["/login", "/signup"];

export const isAuthPath = (pathname: string): boolean =>
  AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

/** True when the query carries an auth token the pixel must not report. */
export const hasSensitiveSearch = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return Array.from(params.keys()).some((key) => SENSITIVE_PARAMS.has(key.toLowerCase()));
};

/** Path plus query for analytics: no query on auth pages, sensitive parameters removed elsewhere. */
export const analyticsPath = (pathname: string, search: string): string => {
  if (isAuthPath(pathname)) return pathname;
  const params = new URLSearchParams(search);
  Array.from(params.keys()).forEach((key) => {
    if (SENSITIVE_PARAMS.has(key.toLowerCase())) params.delete(key);
  });
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};
